module.exports = __webpack_public_path__ + "static/media/shape-empty-field.9a8db778.svg";